import * as React from "react";
const SvgArrowLineRight20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M3 11V9h10.172l-2.423-2.422 1.414-1.415L17 10l-4.837 4.837-1.414-1.415L13.172 11H3Z"
    })
  );
export default SvgArrowLineRight20Px;
